import type { TFunction } from 'i18next';
import { isRoomFamily } from './useCases';

/**
 * Labels per use case, read through translation keys that carry the use case
 * in their name (`issue_report.<useCase>`, `invoice.service_type_<useCase>`,
 * …), so a room use case that goes live needs its keys in de.json and en.json,
 * not another branch at every screen. `i18n/keyParity.test.ts` keeps the two
 * languages equal; `useCaseLabels.test.ts` checks every live room use case has
 * each key.
 */

/** The noun every value without a room noun of its own showed before. */
const FALLBACK_ROOM_NOUN = 'apartment';

/**
 * The use case whose room noun a label shows: a live room use case its own
 * (venue, apartment, hall), every other value the apartment noun, which is
 * what the `=== 'venue' ? venue : apartment` labels it replaces answered.
 */
export const roomNounOf = (useCase: string | null | undefined): string => {
    const value = String(useCase ?? '').trim().toLowerCase();
    return isRoomFamily(value) ? value : FALLBACK_ROOM_NOUN;
};

/** A service's name in the service-type selectors (`service_type_selector.<service>`). */
export const serviceTypeLabel = (t: TFunction, service: string): string =>
    t(`service_type_selector.${service}`, { defaultValue: service });
